import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Article as ZinniaArticle, ArticleDate, ArticleMeta, ArticleReadTime, } from '@zapier/design-system';
import md5 from 'md5';
import { RichText } from '../RichText';
export function Article(props) {
    const getGravatarUrl = () => {
        return (props.authorEmail &&
            'https://www.gravatar.com/avatar/' +
                md5(props.authorEmail) +
                '?d=https://secure.gravatar.com/avatar/b9fa8353122853002d8dcffc2c775182');
    };
    return (_jsx(ZinniaArticle, { author: {
            name: props.authorName,
            imageUrl: props.authorImageUrl || getGravatarUrl(),
        }, category: props.category, categoryUrl: props.categoryUrl, description: props.description && (_jsx(RichText, { backgroundColor: "neutral100", html: props.description })), imageUrl: props.imageUrl, label: props.label, labelIcon: props.labelIcon, labelVariant: props.labelVariant, layout: props.layout, meta: (props.metaDate || props.metaReadTime) && (_jsxs(ArticleMeta, { children: [props.metaDate && _jsx(ArticleDate, { date: props.metaDate }), props.metaReadTime && (_jsx(ArticleReadTime, { minutes: props.metaReadTime }))] })), size: "medium", title: props.title, url: props.url }));
}
//# sourceMappingURL=Article.js.map